import { checkboxPropsSchema } from '../component-catalog.js';
export const checkboxDefinition = {
    type: 'Checkbox',
    category: 'interactive',
    propsSchema: checkboxPropsSchema,
    isDataBacked: false,
    needsMeasuredDims: false,
    description: 'Checkbox input for boolean state. Props: checked?, label?.',
};
//# sourceMappingURL=Checkbox.js.map